import React, { useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';
import { HeartRating } from '../../../Constant';

const HeartRatingClass = () => {
  const [heart, setHeart] = useState(4);
  return (
    <Col xl='6' lg='12' md='6'>
      <Card>
        <HeaderCard title={HeartRating} />
        <CardBody>
          <div className='rating'>
            <Rating initialRating={heart} emptySymbol='text-primary fa fa-heart-o fa-2x' fullSymbol='text-primary fa fa-heart fa-2x' onClick={(rate) => setHeart(rate)}></Rating>
            <span className='current-rating'>{heart}</span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HeartRatingClass;
